<template>
  <div>
    <div class="accordion" id="accordion">
      <div v-for="(unit, index) in units" :key="index">
        <div class="row mb-2 align-items-center">
          <div class="col-auto pr-0">
            <button class="btn btn-block d-flex align-items-center text-left no-gutters collapsed" role="button"
                    data-toggle="collapse" :data-target="'#unit_' + index" aria-expanded="false"
                    :aria-controls="'unit_' + index">
                            <span class="col-auto pr-3">
                                <svg class="icon m-0">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </span>
              <span class="col-auto">{{ unit.getSpecification(__) }}</span>
            </button>
          </div>
          <span class="col-auto pl-0" v-if="!unit.checkSpace()">
                        <a :id="'space-info-' + index" role="button" tabindex="0"
                           v-b-popover.hover.right="__('lang.kwl.room_overview.space_info')">
                            <svg id="space-info" class="icon m-0 mb-1 text-primary">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </a>
                    </span>
          <div class="col-auto ml-auto" v-if="units.length > 1">
            <div class="dropdown d-inline">
              <button class="btn btn-sm btn-gray-50 text-white border-0 dropdown-toggle no-arrow" type="button"
                      data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">...
              </button>
              <div class="dropdown-menu dropdown-menu-right bg-secondary border-0">
                <a class="dropdown-item text-center" role="button" data-toggle="modal" data-target="#roomModal"
                   data-content="we-room-duplicate"
                   @click="setData(unit.id)">{{ __("lang.kwl.room_overview.copy_all_rooms") }}</a>
              </div>
            </div>
          </div>
          <hr class="w-100 my-0 mx-3"/>
        </div>
        <div class="collapse" :class="index == 0 ? 'show' : ''" :id="'unit_' + index" data-parent="#accordion">
          <RoomTableComponent :unitId="unit.id"></RoomTableComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Unit from "@models/building/Unit";
import Building from "@models/building/Building";
import pageValidation from "@services/validations/pageValidation";

import log from "@services/logger/index";

export default {
  components: {
    RoomTableComponent: () => import("./RoomTableComponent"),
  },
  data() {
    return {
      roomTotalSpace: [],
    };
  },
  methods: {
    setData: function (unitId) {
      this.$store.dispatch("modalSettings/setComponent", "UnitDuplicate");
      this.$store.dispatch("modalSettings/isLarge", false);
      this.$store.dispatch("modalSettings/callRef", {unitId: unitId});
      this.$store.dispatch("modalSettings/open");
    },
  },
  computed: {
    units() {
      return Unit.query().with("rooms").get();
    },
    building() {
      return Building.query().first();
    },

  },
  created() {
    pageValidation.validateRoomsPage();
  },
  mounted() {
    window.scrollTo(0, 0);
    document.getElementsByTagName("body")[0].classList.remove("is-loading");
  },
};
</script>
